module.exports = __webpack_public_path__ + "static/media/orangeext.5c6e6ecc.svg";